module.exports = __webpack_public_path__ + "static/media/down-arrow.35f988e4.svg";